module.exports = __webpack_public_path__ + "img/bg-sm.f397e509.png";